import { StyleSheet } from 'react-native';

import { commonCard } from '../common';
import { colors, spacing, layout } from '../theme';

export const cardStyles = StyleSheet.create({
	// Base card style used in lists
	card: {
		...commonCard, // Shared card base style
		borderRadius: layout.borderRadius.medium,
		padding: spacing.m,
		marginBottom: spacing.m,
		...layout.elevation.medium,
	},

	// Card header with title and optional date
	cardHeader: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: spacing.s,
	},

	statusRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing.s,
	},

	// Card title text
	cardTitle: {
		fontSize: 16,
		fontWeight: 'bold',
		color: colors.text,
	},

	// Secondary text like dates
	cardDate: {
		fontSize: 12,
		color: colors.textSecondary,
	},

	// Card content/description
	cardDescription: {
		fontSize: 14,
		color: colors.text,
		marginBottom: spacing.m,
	},

	// Card footer with status badges, etc
	cardFooter: {
		borderTopWidth: 1,
		borderTopColor: colors.border,
		marginTop: spacing.m,
		paddingTop: spacing.s,
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
	},

	location: {
		paddingTop: 0,
		paddingBottom: 10,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.s,
	},

	locationIcon: {
		marginLeft: spacing.s,
	},

	locationText: {
		fontSize: 14,
		fontWeight: '400',
		textAlign: 'left',
	},

	mapDistance: {
		flexDirection: 'row',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
		gap: spacing.s,
	},

	distanceText: {
		textAlign: 'right',
		fontSize: 12,
		color: '#888',
		marginTop: 2,
	},

	mapDistanceContainer: {
		flexShrink: 0,
		flexDirection: 'row',
		alignItems: 'center',
	},

	locationLeft: {
		flex: 1,
	},

});
